export default __webpack_public_path__ + "static/media/doc-check-circle.29891d2a.svg";